/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes, { element } from 'prop-types';
import './formTagsPreview.scss';

/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const SingleTagPreview = (props) => {
  const {
    value,
    rawValue,
    mode
  } = props;
  const [myTag,setMyTag] =useState(null);
  const [styleText,setStyleText] =useState(null);
  
  useEffect(() => {
    let myValues=null;
    if (rawValue) {
      myValues = {
        name: rawValue.name,
        label: rawValue.label,
        tagMode: rawValue.tagMode,
        textColor: rawValue.textColor,
        bkColor: rawValue.bkColor,
        font: rawValue.font,
        width: rawValue.width,
        icon: rawValue.icon,
        iconUrl: rawValue.iconUrl || rawValue.icon?.image,
        tagPosition: rawValue.props?.position ?? 'button-center',
        minWidth: rawValue.props?.minWidth ?? null,
        fixedWidth: rawValue.props?.fixedWidth ?? null,
      };
      setMyTag(myValues);
    
    }else{
        myValues = {
        "name": value.name,
        "label": value.label,
        "tagMode": value.tagMode,
        "textColor": value.textColor,
        "bkColor": value.bkColor,
        "font": value.font,
        "width": value.width,
        "icon": value.icon,
        "iconUrl": value.iconUrl || (value.icon ? value.icon.image : null),
        "tagPosition": value.tagPosition ?? 'button-center',
        "minWidth": value.minWidth ?? null,
        "fixedWidth": value.fixedWidth ? value.fixedWidth : null,
      };
      setMyTag(myValues);
              
    }
    setStyleText( myValues.width=="fixed" ? { width: `${myValues.fixedWidth}px` } : {minWidth:(myValues.minWidth>70?"100%":myValues.minWidth+"%")});
  }, [rawValue,value]);

  return (
    <>
    {myTag && myTag.tagMode && myTag.tagMode=="text" && 
      <div className={"tag-button"+" tag-width-"+(myTag.width=="fixed" && myTag.fixedWidth?"custom":myTag.width)} data-name={myTag.name} style={{...styleText}}>
       <div className={"tag-block"} style={{backgroundColor:myTag.bkColor,color:myTag.textColor}}>
        {myTag && myTag.icon && myTag.icon.image && <img className="tag-image" src={myTag.icon.image}/>}
        {myTag && myTag.label && <span className={"font-"+myTag.font}>{myTag.label}</span>}
      </div> 
    </div>}

      {myTag && myTag.tagMode == "image" && myTag.iconUrl &&
        <div className={`tag-${myTag.tagPosition}`}><img className="tag-logo-image" style={{ textAlign: 'center' }} src={myTag.iconUrl} alt="" /> </div>
      }  
      {/* {myTag && myTag.tagMode=="image" && <div className="tag-button-center" ><img style={{textAlign:'center'}} src={myTag.iconUrl} /></div>} */}
    </>
  );
};

SingleTagPreview.propTypes = {
  size: PropTypes.string,
};

SingleTagPreview.defaultProps = {
  size: 'xxl',
};

export default SingleTagPreview;
